import React from 'react'
import {MailchimpTag, useTestTag} from 'Event/mailchimp'
import {MAILCHIMP} from 'organization/Event/Services/ServicesProvider'
import TestTagButton from 'organization/Event/Form/TestTagButton'

export default function TestMailchimpTagButton(props: {
  tag: MailchimpTag | null
}) {
  const addTag = useTestTag()

  return (
    <TestTagButton tag={props.tag} integration={MAILCHIMP} addTag={addTag} />
  )
}
